/**
 * 自动定位节点
 * 2017-12-18
 * Bai.Zhiming
 */
'use strict';
angular.module('locationNodeServiceModule', [])
    .factory('locationNodeService', ['trsHttpService', 'localStorageService', '$q', function(trsHttpService, localStorageService, $q) {
        return {

            /**
         * [locationBySearch description] 定位方法(通过搜索)
         * @param  {[type]} pathArray    [description] 路径节点数组
         * @param  {[type]} tree         [description] 树对象
         * @param  {[type]} success      [description] 成功回到 函数
         * @return {[type]}              [description]
         */
            locationBySearch: function(pathArray, tree, success) {
                var treeIndex = 0;
                var expanded = [];
                for (var j = 0; j < tree.length; j++) {
                    var attribute = getAttribute(pathArray[0]);
                    if (pathArray[0][attribute] === tree[j][attribute]) {
                        if (pathArray.length === 1) {
                            success(tree, tree[j], expanded);
                        } else if (pathArray.length !== 0) {
                            treeIndex++;
                            expanded.push(tree[j]);
                            forEachNodeArray(tree[j], function(selectedNode) {
                                success(tree, selectedNode, expanded);
                            });
                        }
                        break;
                    }
                }

                /* forEachNodeArray(nodeArray, function() {

            });*/
                /**
             * [forEachNodeArray description] 循环遍历路径数组
             * @return {[type]} [description]
             */
                function forEachNodeArray(node, nodeArraySuccess) {
                    var obj = pathArray[treeIndex];
                    var attribute = getAttribute(obj);
                    var nextNode;
                    getChildren(node).then(function(children) {
                        var flag = false;
                        for (var k = 0; k < children.length; k++) {
                            if (children[k][attribute] === obj[attribute]) {
                                nextNode = children[k];
                                flag = true;
                                break;
                            }
                        }
                        if (flag) {
                            if (pathArray.length === treeIndex + 1) {
                                nodeArraySuccess(nextNode);
                            } else {
                                treeIndex++;
                                expanded.push(nextNode);
                                forEachNodeArray(nextNode, nodeArraySuccess);
                            }
                        } else {
                            nodeArraySuccess();
                        }
                    });
                }

                /**
             * [getAttribute description] 获取属性名称
             * @param  {[type]} obj [description] 所选对象
             * @return {[type]}     [description]
             */
                function getAttribute(obj) {
                    var attribute;
                    for (var i in obj) {
                        attribute = i;
                    }
                    return attribute;
                }

                /**
             * [getChildren description] 获取子节点
             * @return {[type]} [description]
             */
                function getChildren(node) {
                    var deffer = $q.defer();
                    var urlArray = node.url.split('/');
                    var params = {
                        typeid: urlArray[0],
                        serviceid: urlArray[1],
                        modelId: urlArray[2]
                    };
                    var paramArray = node.param_level.split('&');
                    for (var i in paramArray) {
                        var attribute = paramArray[i];
                        params[attribute] = node[attribute];
                    }
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        node.CHILDREN = data.content;
                        deffer.resolve(node.CHILDREN);
                    });
                    return deffer.promise;
                }
            },

            /**
         * [locationByLs description] 通过浏览器本地存储的记录自动定位
         * @param  {[type]} pathArray    [description] 路径节点数组
         * @param  {[type]} tree         [description] 树对象
         * @param  {[type]} success      [description] 成功回到 函数
         */
            locationByLs: function(nodeArray, tree, success) {
                var treeIndex = 0;
                var expanded = [];
                for (var j = 0; j < tree.length; j++) {
                    var attribute = getAttribute(nodeArray[0]);
                    if (nodeArray[0][attribute] === tree[j][attribute]) {
                        if (nodeArray.length === 1) {
                            success(tree, tree[j], expanded);
                        } else if (nodeArray.length !== 0) {
                            treeIndex++;
                            expanded.push(tree[j]);
                            forEachNodeArray(tree[j], function(selectedNode) {
                                success(tree, selectedNode, expanded);
                            });
                        }
                        break;
                    }
                }

                /* forEachNodeArray(nodeArray, function() {

            });*/
                /**
             * [forEachNodeArray description] 循环遍历路径数组
             * @return {[type]} [description]
             */
                function forEachNodeArray(node, nodeArraySuccess) {
                    var obj = nodeArray[treeIndex];
                    var attribute = getAttribute(obj);
                    var nextNode;
                    getChildren(node).then(function(children) {
                        var flag = false;
                        for (var k = 0; k < children.length; k++) {
                            if (children[k][attribute] === obj[attribute]) {
                                nextNode = children[k];
                                flag = true;
                                break;
                            }
                        }
                        if (flag) {
                            if (nodeArray.length === treeIndex + 1) {
                                nodeArraySuccess(nextNode);
                            } else {
                                treeIndex++;
                                expanded.push(nextNode);
                                forEachNodeArray(nextNode, nodeArraySuccess);
                            }
                        } else {
                            nodeArraySuccess();
                        }
                    });
                }

                /**
             * [getAttribute description] 获取属性名称
             * @param  {[type]} obj [description] 所选对象
             * @return {[type]}     [description]
             */
                function getAttribute(obj) {
                    return 'name';
                }

                /**
             * [getChildren description] 获取子节点
             * @return {[type]} [description]
             */
                function getChildren(node) {
                    var deffer = $q.defer();
                    var urlArray = node.url.split('/');
                    var params = {
                        typeid: urlArray[0],
                        serviceid: urlArray[1],
                        modelId: urlArray[2]
                    };
                    var paramArray = node.param_level.split('&');
                    for (var i in paramArray) {
                        var attribute = paramArray[i];
                        params[attribute] = node[attribute];
                    }
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        node.CHILDREN = data.content;
                        deffer.resolve(node.CHILDREN);
                    });
                    return deffer.promise;
                }
            },

            /**
         * [recordRouteLocation description] 节点存储以及自动定位
         * @param {[object]} [$scope] [description] 父作用域的$scope
         * @param {string} [type] [description] 所在分类
         * @param {FN} [success] [description] 成功回调函数
         * @return {[type]} [description]
         */
            recordRouteLocation: function($scope, type, success, failed) {
                var self = this;

                /**
             * [recordRoute description] 记录路径
             * @param {object} [$event] [description] 当前节点事件
             * @return {[type]} [description]
             */
                routeMemoryLocation();
                $scope.recordRoute = function($event) {
                    var $parents = $($event.target).parents('li');
                    var obj = {
                        type: type,
                        nodeArray: []
                    };
                    $parents.each(function(index) {
                        var node = angular.copy($(this).data().node);
                        delete node.parentNode;
                        delete node.CHILDREN;
                        obj.nodeArray.unshift(node);
                    });
                    localStorageService.set('resClassifyLeft', JSON.stringify(obj));
                };

                /**
             * [routeMemoryLocation description] 路由记忆功能
             * @return {[type]} [description]
             */
                function routeMemoryLocation() {
                    var routeMemory = localStorageService.get('resClassifyLeft');
                    if (!routeMemory) {
                        failed($scope.treeModel, $scope.treeModel[0], []);
                        return;
                    }
                    routeMemory = JSON.parse(routeMemory);
                    if (routeMemory.type !== type) {
                        failed($scope.treeModel, $scope.treeModel[0], []);
                        return;
                    }
                    self.locationByLs(routeMemory.nodeArray, $scope.treeModel, function(tree, selectedNode, expandedNodes) {
                        success(tree, selectedNode, expandedNodes);
                    });
                }
            }
        };
    }]);
